// How the admin app names a tenant.
//
// A clinic is shown by its name once the clinics list or its summary has
// loaded (`useTenantNames`). Before that, and when the name can't be read,
// it is shown by the first 8 characters of its id, in mono.

export function shortTenantId(tenantId: string): string {
  return tenantId.slice(0, 8);
}

export function minutesLeft(expiresAtMs: number, nowMs: number): number {
  return Math.max(0, Math.ceil((expiresAtMs - nowMs) / 60_000));
}
